export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10074.3622dbae.jpg";